<script setup>
import {
  convertArrayOfObjsToObj,
  useFetchAllResource,
  useFetchResourceUsingId,
  useGetTranslation,
  useRoute,
  useRouter,
  useStore,
} from "@/components/Utils/functions";
import LoadingArea from "@/components/Utils/LoadingArea.vue";
import TransferList from "@/components/Utils/TransferList.vue";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ref, watchEffect } from "vue";
import FormContainer from "./FormContainer.vue";
import apiCall from "@/utils/api";

const store = useStore();
const t = useGetTranslation();
const router = useRouter();
const route = useRoute();

const userId = route?.params?.id;
const {
  isLoading,
  isFetching,
  data: user,
} = useFetchResourceUsingId("user", userId);

const selectedRoles = ref({});
watchEffect(() => {
  console.log(user.value);
  if (!!user.value?.roles) {
    selectedRoles.value = convertArrayOfObjsToObj(user.value.roles, "id");
  }
});

const rolesQuery = useFetchAllResource({
  resourceName: "role",
  normalize: true,
});

const queryClient = useQueryClient();
const updateUserRolesMtn = useMutation({
  mutationFn: async () => {
    await apiCall({
      url: `/api/user_roles/${user.value?.id}`,
      method: "PUT",
      data: { roles: Object.values(selectedRoles.value) },
    });
    queryClient.invalidateQueries({
      queryKey: ["show", "user", user.value?.id],
    });
    queryClient.invalidateQueries({
      queryKey: ["listUsers"],
    });
  },
});

const form = ref(null);
const onFormSubmitted = async () => {
  await updateUserRolesMtn.mutateAsync();
  store.commit("openSnackbar", {
    open: true,
    text: t("userRolesUpdatedMsg"),
    color: "success",
  });
  router.back();
};
</script>

<template>
  <FormContainer :title="$t('userRolesMsg')">
    <v-form ref="form" @submit.prevent="onFormSubmitted">
      <v-row>
        <v-col cols="12">
          <LoadingArea :loading="updateUserRolesMtn.isLoading.value">
            <TransferList
              :items="rolesQuery.data.value"
              :fetchingItems="rolesQuery.isLoading.value || isFetching"
              v-model="selectedRoles"
              itemLabel="name"
              itemValue="id"
              :availableItemsTitle="$t('availableRolesMsg')"
              :assignedItemsTitle="$t('assignedRolesMsg')"
              :transferAllItemsTitle="$t('transferAllRolesMsg')"
              :transferAllItemsConfirmation="
                $t('transferAllRolesConfirmationMsg')
              "
              :removeAllItemsTitle="$t('removeAllRolesMsg')"
              :removeAllItemsConfirmation="$t('removeAllRolesConfirmationMsg')"
            />
          </LoadingArea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex">
          <v-spacer />
          <v-btn
            depressed
            class="primary text-none mt-3 mr-3"
            type="submit"
            :loading="updateUserRolesMtn.isLoading.value"
            :disabled="isFetching || updateUserRolesMtn.isLoading.value"
          >
            {{ $t("saveMsg") }}
            <v-icon right> mdi-content-save </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </FormContainer>
</template>
